/**
 * Service API pour les signalements d'exercices problématiques
 *
 * Gère les appels aux endpoints backend pour :
 * - Résoudre un signalement (admin) ; la liste se lit dans la file de
 *   modération unique (`features/moderation`).
 */

import { ReportType } from '../types';
import { ADMIN_URLS } from '../config/adminApi';
import { createApiClient, withEnv } from '../lib/http';
import { AppEnvironment } from '../config/environment';

/** Labels lisibles pour les types de problème */
export const REPORT_TYPE_LABELS: Record<ReportType, string> = {
  illustration_manquante: 'Illustration manquante',
  contenu_absent: 'Contenu absent',
};

const api = createApiClient();

class ExerciseReportApiService {
  /**
   * Marque un signalement comme résolu (admin).
   */
  static async resolveReport(
    env: AppEnvironment,
    reportId: string
  ): Promise<{ success: boolean }> {
    // Environnement dans l'en-tête, comme ailleurs ; aussi dans le corps pour
    // un serveur pas encore à jour (il lisait le corps seulement).
    const response = await api.put<{ success: boolean }>(
      `${ADMIN_URLS.exerciseReports}/${reportId}/resolve`, { env }, withEnv(env));
    return response.data;
  }
}

export default ExerciseReportApiService;
